/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import { AUTH_HOST } from "./urls.js"

/**
 * The id of the OAuth2 client
 */
export const CLIENT_ID = "webadmin"

/**
 * The url for the authorization server
 */
export const AUTH_URL = AUTH_HOST + "/oauth/authorize"

/**
 * The period in seconds for premature renewal of an access token
 * (This is to decrease the chance of a user running into an expired access token while working with the app)
 */
export const PREMATURE_RENEW_ACCESS_TOKEN_PERIOD = 86400 // 1 day
